import { render } from "./FoldersView.vue?vue&type=template&id=b3599810"
import script from "./FoldersView.vue?vue&type=script&lang=js"
export * from "./FoldersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__